import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from 'services/cognito/lib';

const LoginComponent = () => {
    const navigate = useNavigate();
    const handleLogin = useCallback(async () => {
        const userAlreadyConnected = await authService.login({ lang: 'fr' });
        if (userAlreadyConnected) {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        handleLogin();
    }, [handleLogin]);

    return null;
};

export default LoginComponent;
